var EditDialogButton = require('./editDialogToggleButton');

module.exports = EditDialogButton.extend({
    iconCode: 0xe809,
    color: '#3399FF',
    title: 'Signature Dialog'
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/selectSet/btn/signatureDialogBtn.js
 ** module id = 227
 ** module chunks = 0
 **/